import MyProfileBlock from './MyProfileBlock';
import { MyProfileBlockProps, MyProfileBlockValueProps } from './types';

export type { MyProfileBlockProps, MyProfileBlockValueProps };
export default MyProfileBlock;
